import React from "react";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "@/src/types/SummaryDetailsProps";

const SummaryDetailsProvider = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"membershipType"} caseData={caseData} />

      <SummaryDetailsItem caseData={caseData} fieldPath={"providerType"} />
      <SummaryDetailsItem caseData={caseData} fieldPath={"reasonForDispute"} />

      {caseData.reasonForDispute === "cancellationByProvider" && (
        <SummaryDetailsItem caseData={caseData} fieldPath={"cancellationReceivedDate"} fieldType={"date"} />
      )}
      {caseData.reasonForDispute === "priceIncrease" && caseData.priceIncreaseAnnouncementDate && (
        <SummaryDetailsItem caseData={caseData} fieldPath={"priceIncreaseAnnouncementDate"} fieldType={"date"} />
      )}
      {caseData.reasonForDispute === "cancellationRefused" && (
        <>
          <SummaryDetailsItem caseData={caseData} fieldPath={"cancellationDate"} fieldType={"date"} />
          <SummaryDetailsItem caseData={caseData} fieldPath={"endOfContractDate"} fieldType={"date"} />
          <SummaryDetailsItem caseData={caseData} fieldPath={"opponentReactionToCancellation"} />
          {caseData.opponentReactionToCancellation === "differentDate" && (
            <SummaryDetailsItem caseData={caseData} fieldPath={"endOfContractDateOpponent"} fieldType={"date"} />
          )}
        </>
      )}
      {!!caseData.contractNumber && <SummaryDetailsItem caseData={caseData} fieldPath={"contractNumber"} />}
    </>
  );
};

export default SummaryDetailsProvider;
